import { render, staticRenderFns } from "./StudyConversationMessageTimestamp.vue?vue&type=template&id=3131303e&scoped=true"
import script from "./StudyConversationMessageTimestamp.vue?vue&type=script&lang=js"
export * from "./StudyConversationMessageTimestamp.vue?vue&type=script&lang=js"
import style0 from "./StudyConversationMessageTimestamp.vue?vue&type=style&index=0&id=3131303e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3131303e",
  null
  
)

export default component.exports